var map = {
	"./brain-logo-blue.svg": 7505,
	"./brain-logo.svg": 1504,
	"./extensive.svg": 775,
	"./icons/001-category-1.svg": 3509,
	"./icons/001-category.svg": 7507,
	"./icons/002-medicine.svg": 9882,
	"./icons/external.svg": 2916,
	"./icons/menu-default-icon.svg": 4018,
	"./icons/notes.svg": 308,
	"./loading.svg": 1736,
	"./logo-beta.svg": 7912,
	"./logo-white.svg": 5589,
	"./logo.svg": 3233,
	"./practical.svg": 6701,
	"./quick.svg": 4273,
	"./referenced.svg": 7501
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7288;